import { ReactElement } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { ThemeProvider } from 'styled-components'

import { Container, IChipContainerTheme } from 'components/Chip'
import { safeFormatMessage } from 'utils/intl'

export const PaymentSummaryStatusValues = {
  DRAFT: 'DRAFT',
  READY: 'READY',
  SENT: 'SENT',
  ERRORS: 'ERRORS'
} as const

export type EPaymentSummaryStatus = (typeof PaymentSummaryStatusValues)[keyof typeof PaymentSummaryStatusValues]

const getTheme = (status: EPaymentSummaryStatus): IChipContainerTheme => {
  switch (status) {
    case PaymentSummaryStatusValues.DRAFT:
      return { backgroundColor: '#CFB1F3', color: '#fff' }
    case PaymentSummaryStatusValues.READY:
      return { backgroundColor: '#00C875', color: '#fff' }
    case PaymentSummaryStatusValues.SENT:
      return { backgroundColor: '#8F8BFF', color: '#fff' }
    case PaymentSummaryStatusValues.ERRORS:
      return { backgroundColor: '#FF627B', color: '#fff' }
    default: {
      return { backgroundColor: '#fff', color: '#000' }
    }
  }
}

const paymentSummaryStatusMessages = defineMessages({
  [PaymentSummaryStatusValues.DRAFT]: {
    id: 'paymentSummary.status.draft',
    defaultMessage: 'Draft'
  },
  [PaymentSummaryStatusValues.READY]: {
    id: 'paymentSummary.status.ready',
    defaultMessage: 'Ready'
  },
  [PaymentSummaryStatusValues.SENT]: {
    id: 'paymentSummary.status.sent',
    defaultMessage: 'Sent'
  },
  [PaymentSummaryStatusValues.ERRORS]: {
    id: 'paymentSummary.status.errors',
    defaultMessage: 'Errors'
  }
})

interface IPaymentSummaryStatusProps {
  status: EPaymentSummaryStatus
}

export const PaymentSummaryStatus = ({ status }: IPaymentSummaryStatusProps): ReactElement => {
  const intl = useIntl()

  return (
    <ThemeProvider theme={getTheme(status)}>
      <Container>{safeFormatMessage({ intl, messages: paymentSummaryStatusMessages, key: status })}</Container>
    </ThemeProvider>
  )
}
